import React from "react";
import "./Footer.css";
import { BsInstagram } from "react-icons/bs";
import { BsLinkedin } from "react-icons/bs";
import { BsGithub } from "react-icons/bs";
import { SiLeetcode } from "react-icons/si";

const Footer = () => {
  return (
    <footer id="footer">
      <a href="# " className="footer__logo">
        Mayank Kumar Shah
      </a>
      <ul className="permalinks">
        <li>
          <a href="# ">Home</a>
        </li>
        <li>
          <a href="#about ">About</a>
        </li>
        <li>
          <a href="#experience ">Experience</a>
        </li>
        <li>
          <a href="#services ">Services</a>
        </li>
        <li>
          <a href="#portfolio ">Portfolio</a>
        </li>
        <li>
          <a href="#testmonial ">Testimonials</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div className="footer__social">
        <a href="https://www.instagram.com/" target="_1">
          <BsInstagram />
        </a>
        <a href="https://www.linkedin.com/in/mayank-kr-shah/" target="_2">
          <BsLinkedin />
        </a>
        <a href="https://github.com/Mayank-kr-sh" target="_3">
          <BsGithub />
        </a>
        <a href="https://leetcode.com/Mayank-kr-sh109/" target="_4">
          <SiLeetcode />
        </a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Mayank Kumar Shah. All rights reserved</small>
      </div>
    </footer>
  );
};

export default Footer;
